<template>
  <div class="input-style">
    <input
      id="password"
      :value="passwordValue"
      type="password"
      autocomplete="off"
      @change="changePassword"
      placeholder="パスワード"
    />
    <p class="password-text">※8文字以上32文字以下の英数字</p>
  </div>
</template>

<script>

export default {
  data() {
    return {
      passwordValue: "",
    };
  },
  methods: {
    changePassword(e) {
      const val = e.target.value;
      this.passwordValue = val;
      this.$emit("handle-change-password", this.passwordValue);
    }
  }
};
</script>

<style>
.password-text {
  display: inline-block;
  color: white;
  margin: 0;
  font-size: 90%;
  text-align: left;
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/molecules/InputPassword.vue